export default "__VITE_ASSET__b8d9536b__"